import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {BehaviorSubject} from 'rxjs';
import {EtayssirService} from '../../../../../../../core/services/etayssir.service';
import {DocumentModel} from '../../../../../../../core/ek-e-commerce/ek-models/document.model';
import {FolderVerificationService} from '../../../../../../../core/services/folder-verification.service';

@Component({
    selector: 'kt-information-compliment-dialog',
    templateUrl: './information-compliment-dialog.component.html',
    styleUrls: ['./information-compliment-dialog.component.scss']
})
export class InformationComplimentDialogComponent implements OnInit {

    currentRole = '';

    private loading$ = new BehaviorSubject<boolean>(false);
    spinner$ = this.loading$.asObservable();

    crempaDocuments: DocumentModel [] = [];

    constructor(public dialogRef: MatDialogRef<InformationComplimentDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: { requestNumber: string, folderId: number },
                protected folderVerificationService: FolderVerificationService,
                private etayssirService: EtayssirService,
    ) {
        this.currentRole = JSON.parse(localStorage.getItem('currentUser')).roles;
    }

    ngOnInit(): void {
        this.getDocument();
    }

    close() {
        this.dialogRef.close(false);
    }

    getDocument() {
        this.folderVerificationService.documents$.subscribe(documents => {
            if (documents) {
                this.crempaDocuments = documents.filter(
                    (document: DocumentModel) =>
                        document.documentsGender === 'CREAMBA'
                );
            }
        });
    }

    validateFolder() {
        const docTest = this.crempaDocuments[0].documentUrl;
        this.etayssirService.updateCompliantDocumentUrl(this.data.requestNumber, docTest).subscribe({
            next : () => {
                this.dialogRef.close(true);
            },
            error : () => {
                this.dialogRef.close(false);
            }
        });
    }
}
